import type { PostModalMode } from './types';

export const ITEM_CLASS_MAP: Record<string, string> = {
  UBInboxMessage: 'message',
  UBComment: 'comment',
  UBClassRoomPost: 'post',
};

export const POST = 'Post';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';
export const CLOSE = 'Close';

export const DEFAULT_ITEM_CLASS = 'UBClassRoomPost';

export const MESSAGES = {
  edit: {
    success: 'The post has been saved',
    error: 'The post has not been saved',
  },
  create: {
    success: 'A new post has been added',
    error: 'The post has not been added',
  },
} as const;

export const getModalTitle = (mode: PostModalMode, itemLabel: string) =>
  mode === 'create' ? `Create ${itemLabel}` : `Edit ${itemLabel}`;

export const ALERT_TITLE = 'Alert';
export const ALERT_MESSAGE = 'Leaving this page? All progress will be lost';
export const ALERT_CONFIRM_BUTTON_TEXT = 'Okay';
export const ALERT_CANCEL_BUTTON_TEXT = 'Cancel';
export const DEFAULT_POST_PLACEHOLDER = 'Ask or share something';
